import _ from 'lodash';

import { doGetQuery, doPostQuery, doPutQuery, doDeleteQuery } from './utils';

export const apiAddDeck = async (deck: TDeckUpdate): Promise<string> => {
  const { deckUid } = await doPostQuery<{ deckUid: string }>(
    `decks/deck`,
    null,
    {
      deck: {
        lang: deck.lang,
        name: deck.name,
        templateType: deck.templateType,
        exercises: deck.exercises,
        definitionLangs: deck.definitionLangs,
      },
    }
  );
  return deckUid;
};

export const apiUpdateDeck = async (
  deckUid: string,
  deck: TDeckUpdate
): Promise<void> => {
  await doPutQuery<{ deckUid: string }>(`decks/deck/${deckUid}`, null, {
    deck: {
      lang: deck.lang,
      name: deck.name,
      templateType: deck.templateType,
      exercises: deck.exercises,
      definitionLangs: deck.definitionLangs,
    },
  });
};

export const apiDeleteDeck = async (deckUid: string) =>
  await doDeleteQuery<void>(`decks/deck/${deckUid}`);

export const apiGetBackup = (deckUid?: string): Promise<TBackup> =>
  doGetQuery<TBackup>(`decks/backup` + (deckUid ? `?deckUid=${deckUid}` : ''));

export const getBackupFileName = (deckUid?: string): string => {
  const now = new Date();
  const Y = now.getFullYear();
  const m = now.getMonth();
  const d = now.getDate() + 1;
  return `backup.${deckUid ?? 'full'}.${Y}-${m}-${d}.json`;
};

export const apiGetDeck = (deckUid: string): Promise<TDeck> =>
  doGetQuery<TDeck>(`decks/deck/${deckUid}`);

export const apiGetDecks = async () =>
  await doGetQuery<TDeckRich[]>(`decks/list`)
    // sort by [pending words, words.count]
    .then(decks =>
      _.sortBy(decks, deck => {
        const pending = _.sumBy(
          Object.values(deck.status),
          status => status.count
        );
        return pending * 1000 + deck.wordsCount;
      }).reverse()
    );
